var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"adBnr"},[_c('aside',{staticClass:"adBnr__box"},[_c('adsense',{attrs:{"ad-client":"ca-pub-7863370664678184","ad-slot":"8250737602","ad-style":"display:block","ad-format":"auto"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }